module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Graenichen_AG-93e9f921c9314d913d357ee7d28b7a2c.svg";